<template>
  <div class="form-row">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin }">
      <div class="form-group row align-items-center">
        <app-input class="col-sm-8 mt-sm-2"
                   type="single-checkbox"
                   :list-value-field="$t('I Agree')"
                   v-model="policy_declaration.equality"
                   placeholder=""
        />
        <label class="h4 col-sm-12">Policy and Declaration</label>
        <label class="col-sm-12 mb-sm-0">
          This agreement is made under Regulation 5(1) of the Working Time Regulations 1998. You agree that the company will maintain and monitor records of your working hours and make those records available to any authorized inspector.
        </label>

        <label class="h4 col-sm-12">Equality</label>
        <label class="col-sm-12 mb-sm-0">
          We are committed to promoting equality in all aspects of employment. If you require any adjustments to carry out your duties safely, please provide details in a separate comments section. This information will not be used in any decision-making process regarding your application.
        </label>

        <label class="h4 col-sm-12">Working Time Directive</label>
        <label class="col-sm-12 mb-sm-0">
          You may have the opportunity to work more than 48 hours a week regularly. If you choose to accept this opportunity, you must waive your rights regarding this aspect of the Working Time Directive.
        </label>

        <label class="h4 col-sm-12">Termination</label>
        <label class="col-sm-12 mb-sm-0">
          * This agreement remains valid unless terminated with three months' written notice.
        </label>

        <label class="h4 col-sm-12">Data Protection and Privacy Notice</label>
        <label class="col-sm-12 mb-sm-0">
          <b>Our Commitment to Your Data</b><br>
          We process your personal information in compliance with GDPR and other relevant data protection laws to assess your suitability for employment.
          <ul>
            <li>Personal data is processed only as outlined in this notice.</li>
            <li>Data is managed following the below Principles of Data Protection:</li>
            <ul>
              <li>Fairly and lawfully processed</li>
              <li>Processed for limited purposes</li>
              <li>Accurate and up-to-date</li>
              <li>Adequate, relevant, and not excessive</li>
              <li>Retained no longer than necessary</li>
              <li>Processed in line with your rights</li>
              <li>Securely captured and retained</li>
              <li>Transfer of information to your current and future potential employers where necessary</li>
              <li>Not transferred to countries without adequate protection</li>
            </ul>
          </ul>
        </label>

        <label class="h4 col-sm-12">Access to Your Data</label>
        <label class="col-sm-12 mb-sm-0">
          You have the right to:
          <ul>
            <li>Access and view any personal data we hold.</li>
            <li>Request corrections if the data is incomplete or inaccurate.</li>
            <li>Withdraw consent for any data processing activities based on consent.</li>
          </ul>
          Requests for data access will be fulfilled within 40 days. Please contact HR for more information.
        </label>

        <label class="h4 col-sm-12">How We Use Your Data</label>
        <label class="col-sm-12 mb-sm-0">
          Your data is processed for the following purposes:
          <ul>
            <li>Assessing your suitability for employment.</li>
            <li>Meeting legal, statutory, and contractual obligations.</li>
            <li>Performing financial background checks.</li>
            <li>Sending company-related non-intrusive information.</li>
          </ul>
        </label>

        <label class="h4 col-sm-12">Declaration by Applicant</label>
        <label class="col-sm-12 mb-sm-0">
          You agree to the following terms:
          <ul>
            <li>Employment is subject to references and BS7858:2019 screening.</li>
            <li>You authorize the company to conduct:</li>
            <ul>
              <li>Address and ID checks</li>
              <li>Financial checks</li>
              <li>Employment and qualification verifications</li>
              <li>Criminal background checks</li>
            </ul>
          </ul>
        </label>

        <label class="h4 col-sm-12">Your Responsibilities</label>
        <label class="col-sm-12 mb-sm-0">
          <ul>
            <li>Provide genuine documents as proof of identity and address.</li>
            <li>Notify authorities of changes to employment status if unemployed.</li>
            <li>Maintain and renew your Licences (if required).</li>
          </ul>
        </label>

        <label class="h4 col-sm-12">Criminal Background Check</label>
        <label class="col-sm-12 mb-sm-0">
          For positions of trust, the company may apply for a Disclosure.
          <ul>
            <li>A criminal record does not necessarily bar you from employment.</li>
            <li>Criminal record information is treated sensitively and accessed only by authorized personnel.</li>
          </ul>
        </label>

        <label class="h4 col-sm-12">Financial History</label>
        <label class="col-sm-12 mb-sm-0">
          A Credit Reference Check will be conducted under BS 7858:2019. Failure to disclose relevant information will result in a failed application.
        </label>

        <label class="h4 col-sm-12">Applicant Screening</label>
        <label class="col-sm-12 mb-sm-0">
          By applying, you consent to being screened under BS 7858:2019 standards.
          <ul>
            <li>Employment is conditional upon satisfactory screening.</li>
            <li>Providing false statements or omissions may result in application rejection or termination.</li>
          </ul>
        </label>

        <label class="h4 col-sm-12">Data Sharing</label>
        <label class="col-sm-12 mb-sm-0">
          We do not disclose your personal data without consent except where legally required. Third parties involved include may include for vetting and screening services and to confirm your license number, nationality, and right-to-work status.
        </label>

        <label class="h4 col-sm-12">Safeguarding Measures</label>
        <label class="col-sm-12 mb-sm-0">
          We implement the following to protect your data:
          <ul>
            <li>Restricted access controls</li>
            <li>IT authentication and firewalls</li>
            <li>Regular audits</li>
          </ul>
        </label>

        <label class="h4 col-sm-12">Data Retention</label>
        <label class="col-sm-12 mb-sm-0">
          We retain your personal information for as long as legally required. Basic personal data is retained for 6 years post-employment termination for tax purposes.
        </label>

        <label class="h4 col-sm-12">Confidentiality</label>
        <label class="col-sm-12 mb-sm-0">
          As an employee, you may have access to confidential company information. You are required to:
          <ul>
            <li>Keep all company, client, and colleague information confidential.</li>
            <li>Not share sensitive information without proper authorization.</li>
            <li>Comply with all applicable confidentiality agreements and company policies.</li>
          </ul>
        </label>

        <label class="h4 col-sm-12">Acknowledgment</label>
        <label class="col-sm-12 mb-sm-0">
          By signing below, you confirm that:
          <ul>
            <li>You have provided complete and accurate information.</li>
            <li>You understand the terms of this document.</li>
            <li>You are entering into this agreement voluntarily.</li>
            <li>You understand your responsibility to maintain health and safety at work.</li>
            <li>You will not undertake working hours in a manner that puts yourself or others at risk.</li>
            <li>You consent to the processing and retention of your data as outlined above.</li>
          </ul>
          Failure to comply with these obligations may lead to dismissal or withdrawal of employment offers.
        </label>

        <label class="col-sm-12 mb-sm-0">I Agree to Above Clauses, Terms and Conditions</label>
<!--        <label class="col-sm-12 mb-sm-0">-->
<!--          Applicant Signature: ________________________<br>-->
<!--          Date: ________________________-->
<!--        </label>-->

        <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                   type="single-checkbox"
                   :list-value-field="$t('I Agree')"
                   v-model="policy_declaration.applicant_screening"
                   placeholder=""/>
      </div>
    </form>
  </div>
</template>

<script>
import {FormMixin} from "@/core/mixins/form/FormMixin";

export default {
  name: "PolicyDeclaration",
  mixins: [FormMixin],
  props: {
    preloader: {
      type: Boolean,
      default: false
    },
    policy_declaration: {
      type: Object,
      default: () => ({})
    },
    companyInfo: {
      type: Object,
      default: () => ({})
    },
    yesOrNoList: {
      type: Array
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>